export const styleCols: any = { padding: '0 10px' };
